import React from "react";
import { Button } from "components/button";
import { Arrow } from "container/study-abroad/study-abroad.style";
import { ScholarshipCard } from "styles/study_abroad/study-abroad.style";

const ScholarshipComponent = ({
   title,
   date,
   category,
   image,
   onClick,
   responsive,
   advert,
   content,
}) => {
   return (
      <ScholarshipCard onClick={onClick} responsive={responsive}>
         <div style={{ overflow: "hidden" }}>
            <img src={image} alt="bg_image" />
            {!advert ? (
               <div className="card-details">
                  <h5 style={{ textTransform: "capitalize" }}>{title}</h5>
                  <p>Deadline: {date}</p>
                  <h4 style={{ textTransform: "capitalize" }}>{category}</h4>
                  <Button variant="link" size="small">
                     <span style={{ display: "flex", alignItems: "center" }}>
                        Explore
                        <Arrow style={{ marginLeft: "5px" }} />
                     </span>
                  </Button>
               </div>
            ) : (
               <div className="advert-details">
                  <h5 style={{ textTransform: "capitalize" }}>{title}</h5>
                  <p>{advert ? content : null}</p>
               </div>
            )}
         </div>
      </ScholarshipCard>
   );
};

export default ScholarshipComponent;
